export enum MediaPreviewKind {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
}
